import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class RedirectService {

  constructor(private router: Router) { }

  redirectToPublic() {
    this.router.navigate(['welcome'])
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/redirect.service.ts